import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
export default {
  title: 'Audio config',
  attributeName: 'audio',
  default:[],
  validationUrl:'live',
  hiddenJsonComponent:true,
  fields: [
    {
      attributeName: 'uniqueId',
      label: 'UNIQUEID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'parentUID',
      label: 'PARENTUID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'language',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'language',
      label: 'language',
      required: true,
      default:'',
      pattern: /^[A-Za-z-]+$/,
      helpText: 'Set the video language.',
      errorText: '',
      visibleWhen:[{"field":"deploymentType","value":'ott'}],
    },
    {
      attributeName: 'audioVariant',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'text or number',
      itemLabel: 'Audio variant',
      columns: 2,
      label: 'Audio variant',
      pattern: /^[a-zA-Z0-9]+$/,
      required: true,
      helpText: 'Chosoe the http audio variant',
      errorText: '',
      classCss:"jsonComponent__width100",
      visibleWhen:[{"field":"deploymentType","value":'ott'}],
    
    },
     {
      attributeName: 'audioChannels',
      type: FormInputTypes.SELECT,
      label: 'Audio channels',
      default:2,
      options: [
        { name: '2', value: '2' },
        { name: '5.1', value: '5.1' },
        { name: '7.1', value: '7.1' },
      ],
      helpText: 'Set an audio channels.',
      errorText: '',
      visibleWhen:[{"field":"deploymentType","value":'ott'}],

    },
  ]
};
